import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import BrainIcon from '~/modules/valuation/pages/AddValuation/AILoadingAnimation/BrainIcon';
import StarIcon from '~/modules/valuation/pages/AddValuation/AILoadingAnimation/StarIcon';

export function AILoadingAnimation() {
  const { locale } = useParams();
  return (
    <div className="flex flex-col items-center justify-center w-full">
      <motion.div
        className="relative mb-6"
        animate={{
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      >
        <motion.div
          className="absolute inset-0 w-32 h-32 rounded-full bg-[#0277BD]/20"
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.5, 0, 0.5],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />

        <motion.div
          className="absolute inset-0 w-32 h-32 rounded-full bg-[#0277BD]/30"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.7, 0, 0.7],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.3,
          }}
        />

        <div className="relative w-32 h-32 rounded-full bg-gradient-to-br from-[#0277BD] to-[#01579B] flex items-center justify-center shadow-2xl">
          <BrainIcon />
        </div>

        {[0, 1, 2, 3].map((i) => (
          <motion.div
            key={i}
            className="absolute"
            style={{
              top: '50%',
              left: '50%',
            }}
            animate={{
              x: [0, Math.cos((i * Math.PI) / 2) * 80, 0],
              y: [0, Math.sin((i * Math.PI) / 2) * 80, 0],
              opacity: [0, 1, 0],
              scale: [0, 1, 0],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: i * 0.2,
            }}
          >
            <StarIcon />
          </motion.div>
        ))}
      </motion.div>

      <div className="relative w-full max-w-md h-1 bg-gray-200 rounded-full overflow-hidden mb-6">
        <motion.div
          className="absolute inset-0 h-full bg-gradient-to-r from-transparent via-[#0277BD] to-transparent"
          animate={{
            x: locale === 'ar' ? [200, -400] : [-200, 400] /* [200, -400] */,
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'linear',
          }}
        />
      </div>
    </div>
  );
}
